export default "__VITE_PUBLIC_ASSET__204eaa9f__"